import * as React from "react";
import { connect } from "react-redux";
import { State } from "../model/State";

import { DispatchType } from "../../shared/utilities";
import { addArrayElement } from "../actions/AddArrayElement";
import { removeArrayElement } from "../actions/RemoveArrayElement";
import { reorderArrayElement } from "../actions/ReorderArrayElement";
import { changeFromArrayToExpressionType } from "../actions/UpdateParameter";
import { IParameterSchema } from "../model/IProcessData";

import { default as ComplexParameter } from "./ComplexParameter";

export const TaskParameters: React.FC<TaskParametersProps> = (props: TaskParametersProps) => {

    function handleArrayItemAdd(key: string, parameters: any) {
        props.onArrayItemAdd(props.id, key, parameters);
    }

    function handleArrayItemRemove(key: string, index: number) {
        props.onArrayItemRemove(props.id, key, index);
    }

    if (props.argumentJson) {
        const schema = {} as IParameterSchema;
        schema.subParameters = props.argumentJson;

        return (<ComplexParameter
            existingParameters={props.existingParameters}
            passedKey=""
            taskKey={props.taskKey}
            elementId={props.id}
            argumentJson={schema}
            onArrayItemAdd={handleArrayItemAdd}
            onArrayItemRemove={handleArrayItemRemove}
            onChangeArrayToExpression={props.onChangeArrayToExpression}
            onArrayItemIndexChange={props.handleArrayItemIndexChange}
        />);
    } else {
        return null;
    }
};

interface TaskParametersOwnProps {
    id: string;
    taskKey: string;
    existingParameters: any;
    argumentJson: IParameterSchema[];
}

interface TaskParametersStateProps {

}

interface TaskParametersDispatchProps {
    onArrayItemAdd: (id: string, key: string, defaultParameters: any) => void;
    onChangeArrayToExpression: (key: string) => void;
    onArrayItemRemove: (id: string, key: string, index: number) => void;
    handleArrayItemIndexChange: (key: string, oldIndex: number, newIndex: number) => void;
}

export type TaskParametersProps = TaskParametersOwnProps & TaskParametersStateProps & TaskParametersDispatchProps;
const mapStateToProps = (state: State, ownProps: TaskParametersProps): TaskParametersStateProps => {
    return {
    };
};

const mapDispatchToProps = (dispatch: DispatchType<State>, ownProps: TaskParametersOwnProps): TaskParametersDispatchProps => {
    return {
        onArrayItemAdd: (id: string, key: string, defaultParameters: IParameterSchema) => dispatch(addArrayElement(id, key, defaultParameters)),
        onArrayItemRemove: (id, key, index) => dispatch(removeArrayElement(id, key, index)),
        onChangeArrayToExpression: (key: string) => dispatch(changeFromArrayToExpressionType(ownProps.id, key)),
        handleArrayItemIndexChange: (key: string, oldIndex: number, newIndex: number) => dispatch(reorderArrayElement(ownProps.id, key, oldIndex, newIndex))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskParameters);
